<template>
  <Loading />
  <div class="app-wrapper">
    <Navbar />

    <main class="main-content">
      <router-view />
    </main>

    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
// import Loading from "@/components/Loading.vue";

export default {
  name: "App",
  components: {
    Navbar,
    Footer,
    // Loading,
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 
    /* 中文字體優先順序 */ "Noto Sans TC", "Microsoft JhengHei",
    /* 英文字體 */ Arial, sans-serif;
  background-color: #f5f7fa;
}

html {
  overflow-y: scroll !important;
  overflow-x: hidden;
}

.app-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  width: 100%;
}

/* 確保所有主要文字元件都會跟著縮放 */
body,
p,
a,
span,
div,
h1,
h2,
h3,
h4,
h5,
h6,
button,
input,
textarea {
  font-family: inherit;
}

/* ===============================
   全站字體大小控制（只負責放大）
   預設：沒有任何 class
================================ */

/* 只在螢幕寬度 < 1024px 時套用字體放大 */
@media (max-width: 1023px) {
  /* 大 */
  html.font-size-large {
    font-size: 1.5rem;
  }

  /* 特大 */
  html.font-size-extra-large {
    font-size: 2rem;
  }
}
</style>
